export default __webpack_public_path__ + "static/media/sounds/ran_numbers_practice_instruction_general_alyx_alyx.mp3";